import React from "react";
import styled from "styled-components";
import { ParkBg } from "../../assets/images";

const BookSuccessBanner = ({}) => {
  return (
    <>
      <BookSuccessBannerContainer>

      </BookSuccessBannerContainer>
    </>
  );
};

const BookSuccessBannerContainer = styled.div`
  height: 18rem;
  background: url(${ParkBg});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  display: flex;
  justify-content: center;
  position: relative;
`;



export default BookSuccessBanner;
